import { combineReducers } from 'redux';
import reportDefinitions from './reportDefinitions';
import metricsDefinitions from './metricsDefinitions';
import isFiltersDirty from './isFiltersDirty';
import { shopFilters, barberFilters } from './filters';
import { reportData, isReportDataFetched } from './reportData';

export default combineReducers({
  reportDefinitions,
  metricsDefinitions,
  shopFilters,
  barberFilters,
  isFiltersDirty,
  reportData,
  isReportDataFetched,
});
